/**
 * Created by alex.shmaltsuev on 2016-05-09.
 */
import PropTypes from 'prop-types';

import React from 'react';
import IndexStyle from './style.scss';
import { Tab, Accordion, Panel, Badge } from 'react-bootstrap';
import NoDataTab from './noDataTab';
import MobileTab from './mobileTab';
import WidgetTab from './widgetTab';
import FullTab from './fullTab';
import SRListItem from './srListItem';
import MobileListItem from './mobileListItem';
import PendingActionListItem from './pendingActionListItem';
import { bindActionCreators } from 'redux';
import * as scoreBoardActions from '../../actions/scoreBoard';
import * as reportAnalytics from '../../actions/analytics';
import * as chargerActions from '../../actions/app';
import { connect } from 'react-redux';
import C from '../../constants/scoreBoard';
import C_APP from '../../constants/app';
import intlC from '../../constants/intl';
import C_A from '../../constants/analytics';
import * as scoreBoardHelper from './scoreBoardHelper';
import { Link } from 'react-router-dom';
import C_R from '../../constants/routes';
import Style from './widgetTab.scss';
import StyledTabs from '../utils/Styled/tabs';
import styled from 'styled-components';
import Cx from 'classnames';
import ScoreboardFilter from './scoreboardFilter';
import axiosInstance from 'axios';

const StyledWidgetPanel = styled.div`
        background-color: ${props => props.theme.brandColor};
        padding: 10px;
        color: ${props => props.theme.brandContrast};
        .badgeActive {
            background-color: ${props => props.theme.brandContrast};
            color: ${props => props.theme.brandColor};
        }        
`;

const StyledShowAllPanel = styled(Panel)`
    &.mobileScoreboard {
        background-color: transparent;
     }
    .panel-heading.panel-heading {
        background-color: ${props => props.theme.brandColor};
        border-color: ${props => props.theme.brandColor};
    }
    .panel-heading.panel-heading .badge {
        color: ${props => props.theme.brandColor};
        background-color: ${props => props.theme.brandContrast};
    }
`;

const StyledIcon = styled.span`
    color: ${props => props.theme.brandContrast};        
`;

export class ScoreBoardComp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            checkBoxObject: {}, // object with all of the checkboxes and their states by tab id
            [C.ACTIVE_REQUESTS_ID]: -1,
            [C.CLOSED_REQUESTS_ID]: -1,
            [C.SUPERVISED_REQUESTS_ID]: -1,
            [C.PENDING_REQUESTS_ID]: -1,
            toggleClass: 'hide'
        }
        this.showFilter = true;
        this.srType = {
            activeSrs: 'sr',
            closedSrs: 'sr',
            supervisedSrs: 'sr',
            workflowActions: 'action_item'
        };
        this.categoriesFilter = { first: C.CATEGORY_TYPE.FIRST, second: C.CATEGORY_TYPE.SECOND, third: C.CATEGORY_TYPE.THIRD };
        this.handleClick = this.handleClick.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleExportToExcel = this.handleExportToExcel.bind(this);
        this.handleExportToPdf = this.handleExportToPdf.bind(this);
    }

    handleClick(event) {
        if (event.target.id != undefined &&  (event.target.id === 'exportSelected' || event.target.id === 'printSelected')) {
            return;
        }
        let toggle = this.state.toggleClass === 'hide' ? '' : 'hide';
        this.setState({ toggleClass: toggle });
    }

    handleClickOutside(event) {
        if (event.target.currentSrc === undefined || !event.target.currentSrc.indexOf('more-actions-icon') > 0) {
            this.setState({ toggleClass: 'hide' });
        }
    }

    exportFileDownload (isPrintParam,fileName,contentType) {
        
        let exportUrl = '/sspneuprint?listViewName=';

        if (this.props.activeTabName === 'activeSrs') {
            exportUrl = exportUrl + encodeURIComponent('Service Catalog Active Requests') + '&status=OPEN&page=SspSRs';
        } if (this.props.activeTabName === 'closedSrs') {
            exportUrl = exportUrl + encodeURIComponent('Service Catalog Closed Requests') + '&status=CLOSE&page=SspSRs';
        } else  if (this.props.activeTabName === 'workflowActions') {
            exportUrl = exportUrl + encodeURIComponent('Service Catalog Pending Actions') + '&listType=workflowActions&page=SspworkflowActions';
        } else if (this.props.activeTabName === 'supervisedSrs') {
            exportUrl = exportUrl + encodeURIComponent('Service Catalog Supervised Requests') + '&supervised=Y&page=SspSRs';
        }

        exportUrl = exportUrl + isPrintParam;

        if (this.props.activeTabName != undefined &&  this.props.tabs.get(this.props.activeTabName) != undefined && 
            this.props.tabs.get(this.props.activeTabName).get('showAllFilter') != undefined && 
            this.props.tabs.get(this.props.activeTabName).get('showAllFilter').filterData != undefined && 
            this.props.tabs.get(this.props.activeTabName).get('showAllFilter').filterData.length > 0) {
                exportUrl = exportUrl + '&sspFilter=' + encodeURIComponent(btoa(this.props.tabs.get(this.props.activeTabName).get('showAllFilter').filterData));
            }

        let timeStamp = new Date().getTime();
        let fileURL = exportUrl + '&stamp=' + timeStamp;
        
        axiosInstance.get(fileURL,{ responseType: 'blob'})
                .then((result) => {
             
                    var fileLink = document.createElement('a');
                    const url = window.URL.createObjectURL(new Blob([result.data],{type: contentType}));
                    fileLink.href = url;
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    
                    fileLink.click();
                })

    }

    handleExportToExcel() {
        this.exportFileDownload('&print=false','export.csv','text/x-csv');
        this.setState({ toggleClass: 'hide' });
    }

    handleExportToPdf() {
        this.exportFileDownload('&print=true','report.pdf','application/pdf');
        this.setState({ toggleClass: 'hide' });
    }
    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    render() {
        const ScoreBoardTabs = this.props.tabsOrder.map((tabName) => {
            let { listItemsArray, totalListItemsCount } = scoreBoardHelper.requestsPerTab(tabName, this.props);
            return this.getTab(listItemsArray, tabName, totalListItemsCount);
        });
        let filterSelected = {};
        let filterSelectedPrev = {};
        if (this.props.tabs && this.props.activeTabName && this.props.tabs.get(this.props.activeTabName).get(C.SHOW_ALL_FILTER)) {
            filterSelected = this.props.tabs.get(this.props.activeTabName).get(C.SHOW_ALL_FILTER);
            filterSelectedPrev = { ...filterSelected };
        }
        let hint = this.props.intlObject['ssp.scoreboard.filter.enabled'];
        if (this.props.tabs && this.props.activeTabName && this.props.tabs.get(this.props.activeTabName).get('showAllFilter')) {
            hint = this.props.tabs.get(this.props.activeTabName).get('showAllFilter').hint || this.props.intlObject['ssp.scoreboard.filter.enabled'];
        }
        const filter = this.showFilter && this.props.isShowAll ?
            <ScoreboardFilter intlObject={this.props.intlObject} initAction={this.initListOfFilters.bind(this)} filterSelected={filterSelected} filterSelectedPrev={filterSelectedPrev}
                submitAction={this.updateFilter.bind(this)} asyncOption={this.getOptionsAsync.bind(this)} hint={hint} />
            : null;
        if (this.props.browser.lessThan.small) { //Mobile
            if (this.props.isShowAll) {
                return (
                    <Accordion defaultActiveKey={this.props.activeTabName}
                        activeKey={this.props.activeTabName}
                        onSelect={(key) => this.setActiveTab(key)}>
                        {ScoreBoardTabs}
                    </Accordion>
                )
            } else {
                return (
                    <div>
                        {ScoreBoardTabs}
                    </div>
                )
            }
        } else { //Non-Mobile
            if (this.props.browser.lessThan.medium || this.props.compact) { // iPad portrait or a narrow home page cell, tabs justified

                return (
                    <div>
                        {filter}
                        <StyledTabs id="Tabs" bsStyle='pills' className={Style.tabsJustified}
                            defaultActiveKey={this.props.activeTabName}
                            activeKey={this.props.activeTabName}
                            onSelect={(key) => this.setActiveTab(key)} justified>
                            {ScoreBoardTabs}
                        </StyledTabs>
                    </div>
                );
            } else { // desktop
                return <div>
                    <div className="export">
                        <div id="more_actions_wrapper" className="actions_bar_wrapper">
                            <div id="more_actions_toggle" onClick={this.handleClick}>
                                <img src="../images/more-actions-icon.png" width="20" />
                            </div>
                            <div id="more_actions_content" className={this.state.toggleClass}>
                                <ul id="more_actions_list">
                                    <li onClick={this.handleExportToExcel}>
                                        <p id="exportSelected">{this.props.intlObject['ssp.scoreboard.widget.export.excel']}</p>
                                    </li>
                                    <li onClick={this.handleExportToPdf}>
                                        <p id="printSelected">{this.props.intlObject['ssp.scoreboard.widget.export.pdf']}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {filter}
                    <StyledTabs id="Tabs" bsStyle='pills'
                        defaultActiveKey={this.props.activeTabName}
                        activeKey={this.props.activeTabName}
                        onSelect={(key) => this.setActiveTab(key)} className={`tabs_${this.props.tabsOrder.length}`}>
                        {ScoreBoardTabs}
                    </StyledTabs>
                </div>
            }
        }
    }

    completePendingRequest(event, id) {
        event.preventDefault();
        this.props.scoreboardActions.completePendingItemAction(id, this.props.isShowAll);
    }
    approvePendingRequest(event, id) {
        event.preventDefault();
        this.props.scoreboardActions.approvePendingItemAction(id, this.props.isShowAll);
    }
    rejectPendingRequest(event, id) {
        event.preventDefault();
        this.props.scoreboardActions.rejectPendingItemAction(id, this.props.isShowAll);
    }

    initListOfFilters() {
        let tab = this.props.tabs.get(this.props.activeTabName);
        let badgesCustomFields = tab.get(C.BADGES_CUSTOM_FIELDS);
        let columnsCustomFields = tab.get(C.COLUMNS_CUSTOM_FIELDS);
        let filters = badgesCustomFields.concat(columnsCustomFields);
        let categoryFilter;
        let categoryFilterObj = Object.keys(this.categoriesFilter).map(e => this.categoriesFilter[e])
        filters.forEach(item => {
            if (categoryFilterObj.includes(item)) {
                categoryFilter = categoryFilter || {};
                categoryFilter[item] = item;
            }
        });
        let filterPromise = (filters && filters.length > 0) ?
            axiosInstance.get(`/api/v1/sc/filter/options?tabId=${this.props.activeTabName}&filter=${filters.join(',')}&entity=${this.srType[this.props.activeTabName]}`)
                .then((result) => {
                    return result.data;
                })
            : Promise.resolve([]);

        let categoryPromise = categoryFilter ?
            axiosInstance.get('/api/v1/category').then((result) => {
                let secondId, secondCaption, thirdId, thirdCaption;
                let firstId = C.CATEGORY_TYPE.FIRST;
                let firstCaption = this.props.intlObject['ssp.scoreboard.categories'];
                if (categoryFilter.third_level_category) {
                    thirdId = C.CATEGORY_TYPE.THIRD;
                    thirdCaption = this.props.intlObject['ssp.scoreboard.thirdLevelCategories'];
                    secondId = C.CATEGORY_TYPE.SECOND;
                    secondCaption = this.props.intlObject['ssp.scoreboard.subCategories'];
                }
                if (categoryFilter.problem_sub_type) {
                    secondId = C.CATEGORY_TYPE.SECOND;
                    secondCaption = this.props.intlObject['ssp.scoreboard.subCategories'];
                }
                result.data.values.forEach((first) => {
                    first.id = first.caption;
                    first.values.forEach((second) => {
                        second.id = second.caption;
                        if (second.values) {
                            second.values.forEach((third) => {
                                third.id = third.caption;
                            })
                        }
                    })
                });

                let res = {
                    id: firstId,
                    caption: firstCaption,
                    values: result.data.values,
                    secondCaptions: secondCaption,
                    thirdCaption: thirdCaption,
                    secondId: secondId,
                    thirdId: thirdId
                };
                return res;
            }) : Promise.resolve(false);

        this.props.chargerActions.setFetchingCount(true);
        return Promise.all([filterPromise, categoryPromise]).then((response) => {
            let checkIndex = (arr, item) => {
                let index = arr.indexOf(item);
                return index >= 0 ? index : Infinity;
            }
            let result = response[0];
            let actualFilters = result.map(item => { return item.id });
            actualFilters.push(C.CATEGORY_TYPE.FIRST, C.CATEGORY_TYPE.SECOND, C.CATEGORY_TYPE.THIRD);
            let orderedFilters = filters.filter(item => -1 !== actualFilters.indexOf(item));
            let categoryIndex = Math.min(checkIndex(orderedFilters, C.CATEGORY_TYPE.FIRST), checkIndex(orderedFilters, C.CATEGORY_TYPE.SECOND), checkIndex(orderedFilters, C.CATEGORY_TYPE.THIRD));
            if (response[1] && categoryIndex.toString()) {
                result.splice(categoryIndex, 0, response[1]);
            }
            return result;
        }).finally(() => {
            this.props.chargerActions.setFetchingCount(false);
        });
    }

    updateFilter(filterParams, usedFilters, filterCount) {
        this.props.scoreboardActions.updateFilter(filterParams, this.props.activeTabName);
        this.props.scoreboardActions.getscoreBoardTabs(this.props.isShowAll,this.props.activeTabName);
        this.props.analyticActions.reportAnalytics([C_A.SCOREBOARD, 'used filters', usedFilters]);
        this.props.analyticActions.reportAnalytics([C_A.SCOREBOARD, 'displayed filters', filterCount]);
    }

    getOptionsAsync(filterId, input) {
        return axiosInstance.get(`/api/v1/list/${filterId}?entity=sr&query=${input || ''}`).then((response) => {
            return response.data.values;
        }).then((json) => {
            return { options: json };
        });
    }

    /**
     * initialise the checboxObject with the init data . depending by the the tabArray.
     * @param tabName
     * @param tabArray list items data array .
     */
    initCheckBoxInTab(tabName, tabArray) {
        let checkBoxObjectCopy = Object.assign({}, this.state.checkBoxObject);
        let checkBoxArrayCopy = Object.assign({}, checkBoxObjectCopy[tabName]);
        if (tabArray != undefined) {
            for (let i = 0; i < tabArray.length; i++) {
                checkBoxArrayCopy[tabArray[i].id] = false;
            }
        }
        checkBoxObjectCopy[tabName] = checkBoxArrayCopy;
        this.setState({
            checkBoxObject: checkBoxObjectCopy,
            checkAll: false
        });
    }

    checkListItemCall(tabName, listItemId) {
        let checkBoxObjectCopy = Object.assign({}, this.state.checkBoxObject);
        let tabListItemsCopy = Object.assign({}, checkBoxObjectCopy[tabName]);
        tabListItemsCopy[listItemId] = !tabListItemsCopy[listItemId];
        checkBoxObjectCopy[tabName] = tabListItemsCopy;
        setTimeout(function () {
            this.setState({
                checkBoxObject: checkBoxObjectCopy
            });
        }, 1);
    }

    /**
     * called after checkAll is clicked
     * @param tabName
     * @param startIndex
     * @param endIndex
     * @param state boolean same as the show all checkBox
     */
    checkAllCall(tabName, startIndex, endIndex, state) {
        let checkBoxObjectCopy = Object.assign({}, this.state.checkBoxObject);
        let tabListItemsCopy = Object.assign({}, checkBoxObjectCopy[tabName]);
        let listItemArray = scoreBoardHelper.getTabArrayByName(tabName, this.state, this.props).slice(startIndex, endIndex);
        for (let listItem of listItemArray) {
            if (!checkBoxObjectCopy[tabName].hasOwnProperty(listItem.id)) continue;
            tabListItemsCopy[listItem.id] = state;
        }
        checkBoxObjectCopy[tabName] = tabListItemsCopy;
        this.setState({
            checkBoxObject: checkBoxObjectCopy,
            checkAll: !this.state.checkAll
        });
    }



    getTabComponent(tabName, totalListItemsCount, ScoreBoardTabComp) {
        let tabLabel;
        let activeTabName = this.props.activeTabName;
        let tab = this.props.tabs.get(tabName);
        if (totalListItemsCount > 99) {
            totalListItemsCount = '99+';
        }
        if (this.props.browser.lessThan.small) {
            if (this.props.isShowAll) {
                /* mobile full */
                if (tabName == activeTabName) {
                    tabLabel = <div>
                        <span>{this.props.intlObject[tab.get(C.TAB_CAPTION_KEY)]}</span>
                        <Badge className={IndexStyle.badgeActive}>
                            {totalListItemsCount}
                        </Badge>
                        <div className={Style.panelsCaret}>
                            <StyledIcon className={Cx('iconIssue', 'arrowUpIcon', Style.arrowUpIcon)}></StyledIcon>
                        </div>
                    </div>;
                } else {
                    tabLabel = <div>
                        <span>{this.props.intlObject[tab.get(C.TAB_CAPTION_KEY)]}</span>
                        <Badge className={IndexStyle.badgeActive}>
                            {totalListItemsCount}
                        </Badge>
                        <div className={Style.panelsCaret}>
                            <StyledIcon className={Cx('iconIssue', 'arrowDownIcon', Style.arrowDownIcon)}></StyledIcon>

                        </div>
                    </div>;
                }
                return (
                    <StyledShowAllPanel header={tabLabel}
                        eventKey={tabName}
                        key={tabName}
                        bsStyle='primary' className='mobileScoreboard'>
                        {ScoreBoardTabComp}
                    </StyledShowAllPanel>
                )
            } else {
                /* mobile widget */
                tabLabel = <Link to={C_R.SCOREBOARD_PATH}
                    onClick={() => this.setActiveTab(tabName)}
                    className={Style.showAllMobile}>
                    <div>
                        <span>{this.props.intlObject[tab.get(C.TAB_CAPTION_KEY)]}</span>
                        <Badge className={Cx(IndexStyle.badge, 'badgeActive')}>
                            {totalListItemsCount}
                        </Badge>
                        <StyledIcon className={Cx('iconIssue', 'pull-right', 'arrowRight', Style.arrowRightShowAll)}></StyledIcon>
                    </div>
                </Link>;
                return (
                    <div key={tabName}>
                        <StyledWidgetPanel className={Style.widgetPanel}>
                            {tabLabel}
                        </StyledWidgetPanel>
                        {ScoreBoardTabComp}
                    </div>
                )
            }
        } else {
            //Non-mobile
            let tabTooltip = `${this.props.intlObject[tab.get(C.TAB_CAPTION_KEY)]} ${totalListItemsCount}`;
            if (tabName == activeTabName) {
                tabLabel = <div title={tabTooltip}>
                    <span className='tabTitle'>{this.props.intlObject[tab.get(C.TAB_CAPTION_KEY)]}</span>
                    <Badge className={IndexStyle.badgeActive}>{totalListItemsCount}</Badge>
                    <div className='clearfix'></div>
                </div>;
            } else {
                tabLabel = <div title={tabTooltip}>
                    <span className='tabTitle'>{this.props.intlObject[tab.get(C.TAB_CAPTION_KEY)]}</span>
                    <Badge className={IndexStyle.badge}>
                        {totalListItemsCount}
                    </Badge>
                    <div className='clearfix'></div>
                </div>;
            }
            return (

                <Tab title={tabLabel} eventKey={tabName} key={tabName}>
                    {ScoreBoardTabComp}
                </Tab>
            )
        }
    }

    /**
     * creating and returning the tab (including the items) of the component
     * @param listItemsArray array with the data of the current tab
     * @param tab properties contains data like name ,caption
     * @param totalListItemsCount
     * @returns {XML}
     */
    getTab(listItemsArray, tabName, totalListItemsCount) {
        let ScoreBoardTab;
        let ListItem;
        let tab = this.props.tabs.get(tabName);
        let badgesCustomFields = tab.get(C.BADGES_CUSTOM_FIELDS);
        let columnsCustomFields = tab.get(C.COLUMNS_CUSTOM_FIELDS);
        let noData = tab.get(C.TAB_NO_DATA_CAPTION_KEY);
        let noDataText = this.props.intlObject[noData] ? this.props.intlObject[noData] : '';
        if (this.props.browser.lessThan.small) {
            //Mobile
            ScoreBoardTab = MobileTab;
            ListItem = MobileListItem;
        } else {
            ScoreBoardTab = this.props.isShowAll ? FullTab : WidgetTab;
            ListItem = tabName === C.PENDING_MY_APPROVAL_TAB ? PendingActionListItem : SRListItem;

        }


        /* if there are list items to display */
        if (listItemsArray.length != 0) {
            const listItems = listItemsArray.map((listItem) => {
                let isChecked = false;
                if (this.state.checkBoxObject[tabName] && this.state.checkBoxObject[tabName][listItem.id]) {
                    isChecked = this.state.checkBoxObject[tabName][listItem.id] || false; //to know if the list item is checked
                }

                const listItemData = scoreBoardHelper.getRequestInfoData(listItem);
                const listBadgesData = scoreBoardHelper.getRequestInfoData(listItem, badgesCustomFields);
                const listColumnsData = scoreBoardHelper.getRequestInfoData(listItem, columnsCustomFields);
                const hasApprove = scoreBoardHelper.getPendingHasApprove(listItem);
                const hasEmptyRequired = scoreBoardHelper.getPendinghasEmptyRequred(listItem);
                const actions = {
                    completePendingRequest: this.completePendingRequest.bind(this),
                    approvePendingRequest: this.approvePendingRequest.bind(this),
                    rejectPendingRequest: this.rejectPendingRequest.bind(this)
                };
                return <ListItem isChecked={isChecked}
                    checkListItemCall={this.checkListItemCall.bind(this)}
                    key={listItem.id}
                    listItemId={listItem.id}
                    tabName={listItem.tabName}
                    subTabName={listItem.subTabName}
                    listItemData={listItemData}
                    listBadgesData={listBadgesData}
                    listColumnsData={listColumnsData}
                    enableDirectActions={this.props.permissions.enableDirectActions}
                    hasApprove={hasApprove}
                    hasEmptyRequred={hasEmptyRequired}
                    intlObject={this.props.intlObject}
                    actions={actions}
                    isShowAll={this.props.isShowAll}
                    isPendingActionItem={tabName === C.PENDING_MY_APPROVAL_TAB}

                />;
            });
            const ScoreBoardTabComp = <ScoreBoardTab ref={'tab_' + tabName}
                isCheckAll={this.state.checkAll}
                checkAllCall={this.checkAllCall.bind(this)}
                listItems={listItems}
                setActiveTab={this.setActiveTab.bind(this)}
                tabName={tabName}
                intlObject={this.props.intlObject}
                isShowAll={this.props.isShowAll} 
                customPagination = {e=>{this.customPagination(e, tabName)}}
                paginationPageCount ={Math.ceil(this.getReccordsCountByTabName(tabName)/this.props.recordsDisplayedInLists)}
                />;
            return this.getTabComponent(tabName, totalListItemsCount, ScoreBoardTabComp);
        } else {
            /* display a no data message */

            var noDataComp = <NoDataTab noDataText={noDataText} />;

            return this.getTabComponent(tabName, totalListItemsCount, noDataComp);
        }
    }

    getReccordsCountByTabName(tabName)
    {
        switch (tabName)
        {
            case 'activeSrs':
                return this.props.activeRequestsCount;
            case 'closedSrs':
                return this.props.closedRequestsCount;
             case 'workflowActions':
                return this.props.pendingRequestsCount;
            case 'supervisedSrs':
                return this.props.supervisedRequestsCount;
        }
    }

    customPagination(pageNumber,tabName){
       this.props.scoreboardActions.getscoreBoardTabs(this.props.isShowAll,tabName,(pageNumber-1)*this.props.recordsDisplayedInLists);
}
    /**
     * dispatching an action to update the state of the activeTab
     * @param tabName
     */
    setActiveTab(tabName) {
        if (tabName != this.props.activeTabName) {
            this.props.analyticActions.reportAnalytics([C_A.SCOREBOARD, 'tab change', tabName]);
            this.props.scoreboardActions.updateActiveTabName(tabName);
            this.props.scoreboardActions.getscoreBoardTabs(this.props.isShowAll,tabName)
            // checkbox handling for non-mobile show-all page.
            if (this.props.isShowAll && !this.props.browser.lessThan.small) {
                let listItemArray = scoreBoardHelper.getTabArrayByName(tabName, this.state, this.props);
                this.initCheckBoxInTab(tabName, listItemArray);
                for (let key in this.refs) { //going over the tabs and change the checkAll to false
                    if (this.refs.hasOwnProperty(key)) {
                        let tab = this.refs[key];
                        tab.initState();
                    }
                }
            }
        }
    }
}

ScoreBoardComp.propTypes = {
    tabs: PropTypes.object.isRequired,
    tabsOrder: PropTypes.array.isRequired,
    activeRequestsArray: PropTypes.array,
    activeRequestsArrayWidget: PropTypes.array,
    closedRequestsArray: PropTypes.array,
    closedRequestsArrayWidget: PropTypes.array,
    supervisedRequestsArray: PropTypes.array,
    supervisedRequestsArrayWidget: PropTypes.array,
    pendingRequestsArray: PropTypes.array,
    pendingRequestsArrayWidget: PropTypes.array,
    activeRequestsCount: PropTypes.number,
    closedRequestsCount: PropTypes.number,
    supervisedRequestsCount: PropTypes.number,
    pendingRequestsCount: PropTypes.number,
    activeTabName: PropTypes.string.isRequired,
    scoreboardActions: PropTypes.object.isRequired,
    intlObject: PropTypes.object.isRequired,
    browser: PropTypes.object.isRequired,
    isShowAll: PropTypes.bool.isRequired,
    permissions: PropTypes.object.isRequired,
    analyticActions: PropTypes.object.isRequired,
    showAllFitler: PropTypes.object,
    chargerActions: PropTypes.object.isRequired,
    recordsDisplayedInLists:PropTypes.number.isRequired,
    compact: PropTypes.bool
};

function mapDispatchToProps(dispatch) {
    return {
        scoreboardActions: bindActionCreators(scoreBoardActions, dispatch),
        analyticActions: bindActionCreators(reportAnalytics, dispatch),
        chargerActions: bindActionCreators(chargerActions, dispatch)

    }
}

function mapStateToProps(state) {
    return {
        tabs: state.scoreBoard.get(C.TABS),
        tabsOrder: state.scoreBoard.get(C.TABS_ORDER),
        recordsDisplayedInLists: state.scoreBoard.get('recordsDisplayedInLists'),
        activeRequestsArray: state.scoreBoard.getIn([C.TABS, C.MY_REQUEST_TAB, C.ACTIVE_REQUESTS_ARRAY]),
        activeRequestsArrayWidget: state.scoreBoard.getIn([C.TABS, C.MY_REQUEST_TAB, C.ACTIVE_REQUESTS_ARRAY_WIDGET]),
        closedRequestsArray: state.scoreBoard.getIn([C.TABS, C.RECENTLY_CLOSED_TAB, C.CLOSED_REQUESTS_ARRAY]),
        closedRequestsArrayWidget: state.scoreBoard.getIn([C.TABS, C.RECENTLY_CLOSED_TAB, C.CLOSED_REQUESTS_ARRAY_WIDGET]),
        supervisedRequestsArray: state.scoreBoard.getIn([C.TABS, C.SUPERVISED_REQUESTS_TAB, C.SUPERVISED_REQUESTS_ARRAY]),
        supervisedRequestsArrayWidget: state.scoreBoard.getIn([C.TABS, C.SUPERVISED_REQUESTS_TAB, C.SUPERVISED_REQUESTS_ARRAY_WIDGET]),
        pendingRequestsArray: state.scoreBoard.getIn([C.TABS, C.PENDING_MY_APPROVAL_TAB, C.PENDING_REQUESTS_ARRAY]),
        pendingRequestsArrayWidget: state.scoreBoard.getIn([C.TABS, C.PENDING_MY_APPROVAL_TAB, C.PENDING_REQUESTS_ARRAY_WIDGET]),
        activeRequestsCount: state.scoreBoard.getIn([C.TABS, C.MY_REQUEST_TAB, C.ACTIVE_REQUESTS_COUNT]),
        closedRequestsCount: state.scoreBoard.getIn([C.TABS, C.RECENTLY_CLOSED_TAB, C.CLOSED_REQUESTS_COUNT]),
        supervisedRequestsCount: state.scoreBoard.getIn([C.TABS, C.SUPERVISED_REQUESTS_TAB, C.SUPERVISED_REQUESTS_COUNT]),
        pendingRequestsCount: state.scoreBoard.getIn([C.TABS, C.PENDING_MY_APPROVAL_TAB, C.PENDING_REQUESTS_COUNT]),
        activeTabName: state.scoreBoard.get(C.ACTIVE_TAB_NAME),
        intlObject: state.intl.get(intlC.INTL_OBJECT),
        browser: state.browser,
        permissions: state.app.getIn([C_APP.SSP_PERMISSIONS_LIST]),
        showAllFitler: state.scoreBoard.getIn([C.TABS, state.scoreBoard.get(C.ACTIVE_TAB_NAME), C.SHOW_ALL_FILTER])
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScoreBoardComp);



// WEBPACK FOOTER //
// ./components/Scoreboard/scoreBoardComp.js